/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';

import ProfileGender from './ProfileGender';
import { selectors as listSelectors } from '../../../redux/ducks/lists/lists';

function mapStateToProps(state) {
  const birthSexCollection = listSelectors.getBirthSexCollection(state);
  const genderCollection = listSelectors.getGenderCollection(state);

  const birthSexIdMap = {};
  const birthSexMap = {};
  birthSexCollection.forEach((g) => {
    birthSexIdMap[g.id] = g;
    birthSexMap[g.key] = g;
  });

  const genderMap = {};
  const genderIdMap = {};
  genderCollection.forEach((g) => {
    genderIdMap[g.id] = g;
    genderMap[g.key] = g;
  });

  return {
    genderMap,
    genderIdMap,
    birthSexIdMap,
    birthSexMap,
    requestInitialData: () => {},
  };
}

export default connect(mapStateToProps)(ProfileGender);
